export const SKU_PRICE_TEMPLATES_PATH = '/company/:companyId/:gameId/sku/price-templates'
export const SKU_PRICE_TEMPLATES_CREATE_PATH = '/company/:companyId/:gameId/sku/price-templates/create'
export const SKU_PRICE_TEMPLATES_EDIT_PATH = '/company/:companyId/:gameId/sku/price-templates/:priceTemplateId/edit'
